import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import reportService from "services/ReportService";

export const initialState = {
  loadingCandidateReport: false,
  loadingAgencyReport: false,
  loadingVacancyReport: false,
  candidateReportDetails: {
    agencyCandidateCount: 0,
    candidateCount: 0,
    individualCandidateCount: 0,
    appliedCandidateCount: 0,
    hiredCandidates: 0,
  },
  vacancyReportDetails: {
    closedVacancyCount: 0,
    openedVacancyCount: 0,
    bothVacancyCount: 0,
    candidateVacancyCount: 0,
    agencyVacancyCount: 0,
    vacancyCount: 0,
  },
  agencyReportDetails: {
    agencyCandidateHiredCount: 0,
    agencyCandidateAppliedCount: 0,
    agencyCandidateCount: 0,
    agencyCount: 0,
  },
  loadingExportCandidateToExcel: false,
  loadingExportAgencyToExcel: false,
  loadingExportVacancyToExcel: false,
};

export const CandidateReport = createAsyncThunk(
  "/Report/CandidateReport",
  async (agencyId, { rejectWithValue }) => {
    try {
      const response = await reportService.CandidateReport({ agencyId });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const VacancyReport = createAsyncThunk(
  "/Report/VacancyReport",
  async (_, { rejectWithValue }) => {
    try {
      const response = await reportService.VacancyReport();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const AgencyReport = createAsyncThunk(
  "/Report/AgencyReport",
  async (_, { rejectWithValue }) => {
    try {
      const response = await reportService.AgencyReport();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const ExportCandidateToExcel = createAsyncThunk(
  "/Report/ExportCandidateToExcel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.ExportCandidateToExcel(data);
      const url = window.URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "candidates.xlsx");
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const ExportAgencyToExcel = createAsyncThunk(
  "/Report/ExportAgencyToExcel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.ExportAgencyToExcel(data);
      const url = window.URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "agencies.xlsx");
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const ExportVacancyToExcel = createAsyncThunk(
  "/Report/ExportVacancyToExcel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.ExportVacancyToExcel(data);
      const url = window.URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "vacancies.xlsx");
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(CandidateReport.pending, (state) => {
        state.loadingCandidateReport = true;
      })
      .addCase(CandidateReport.fulfilled, (state, action) => {
        state.loadingCandidateReport = false;
        state.candidateReportDetails = action.payload;
      })
      .addCase(CandidateReport.rejected, (state, action) => {
        state.candidateReportDetails = {};
        state.loadingCandidateReport = false;
      })
      .addCase(VacancyReport.pending, (state) => {
        state.loadingVacancyReport = true;
      })
      .addCase(VacancyReport.fulfilled, (state, action) => {
        state.loadingVacancyReport = false;
        state.vacancyReportDetails = action.payload;
      })
      .addCase(VacancyReport.rejected, (state, action) => {
        state.vacancyReportDetails = {};
        state.loadingVacancyReport = false;
      })
      .addCase(AgencyReport.pending, (state) => {
        state.loadingAgencyReport = true;
      })
      .addCase(AgencyReport.fulfilled, (state, action) => {
        state.loadingAgencyReport = false;
        state.agencyReportDetails = action.payload;
      })
      .addCase(AgencyReport.rejected, (state, action) => {
        state.agencyReportDetails = {};
        state.loadingAgencyReport = false;
      })
      .addCase(ExportCandidateToExcel.pending, (state) => {
        state.loadingExportCandidateToExcel = true;
      })
      .addCase(ExportCandidateToExcel.fulfilled, (state, action) => {
        state.loadingExportCandidateToExcel = false;
      })
      .addCase(ExportCandidateToExcel.rejected, (state, action) => {
        state.loadingExportCandidateToExcel = false;
      })

      .addCase(ExportAgencyToExcel.pending, (state) => {
        state.loadingExportAgencyToExcel = true;
      })
      .addCase(ExportAgencyToExcel.fulfilled, (state, action) => {
        state.loadingExportAgencyToExcel = false;
      })
      .addCase(ExportAgencyToExcel.rejected, (state, action) => {
        state.loadingExportAgencyToExcel = false;
      })

      .addCase(ExportVacancyToExcel.pending, (state) => {
        state.loadingExportVacancyToExcel = true;
      })
      .addCase(ExportVacancyToExcel.fulfilled, (state, action) => {
        state.loadingExportVacancyToExcel = false;
      })
      .addCase(ExportVacancyToExcel.rejected, (state, action) => {
        state.loadingExportVacancyToExcel = false;
      });
  },
});

export const {} = reportSlice.actions;

export default reportSlice.reducer;
